import { PipeDefinitionModel } from './column-definition.model';

export class ColumnDefinitionLightModel {

    constructor(
        public Pos: number,
        public Display: string,
        public Column: string,
        public IsVis: boolean,
        public Hide: boolean = true,
        public Sort: boolean = true,
        public Css: string = null,
        public IsHtml: boolean = false,
        public Pipe: PipeDefinitionModel = null,
        public ExpPipe: PipeDefinitionModel = null,
        public ToolTip: boolean | null = false) {
    }
}